<div class="mat-typography mat-body mat-app-background" id='fc'>

  @if (marketType !== 'individual') {
    <div class="donut-layout">
      <div class='section1'>
        <div [id]="donutChartElementId"></div>
      </div>
      <div class='section3'></div>
      <div class='section2' [class]="{'no-visibility' : hideQuickLinks}">
        <div class="innerSection">
          <div class='link-header'>
            <h2>Quick Links</h2>
          </div>
          
          <app-dynamic-link-layout class="dashboard-quick-links" [linkArray]="quickLinksArray"></app-dynamic-link-layout>
        </div>
      </div>
    </div>
  }

  <div class='body'>

    <div class='header-content'>
      <div class='label1'>
        <h2>Web Application Finder </h2>
        <div class='sub-text'>Applications created in the last 90 days are available to view.</div>
        <div class='search-container'>
          <mat-form-field class='search' appearance="outline">
            <mat-label>WebConfirmation Number</mat-label>
            <input matInput type="textbox" [(ngModel)]="appNumber">
          </mat-form-field>
          <!--Search Button-->
          <button (click)="search(true)" type="submit" mat-raised-button color="primary"
          class="primary-btn">Search</button>
          <button (click)="clearSearch()" type="submit" mat-stroked-button color="primary" class="primary-btn">Clear
          search</button>
        </div>
      </div>
      <div class='label2'>
        <mat-form-field appearance="outline">
          <mat-label>Sort By</mat-label>
          <mat-select aria-label="Sort By" (selectionChange)="sortPlans($event)" [(ngModel)]="sortOption">
            @for (name of sortList; track name) {
              <mat-option [value]="name">
                {{name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!--Filter Section-->
    <div class='filter-section'>
      <div class="filter-label-container">
        @if (!showFilterOptions) {
          <div>
            <a (click)="showFilterOptions = !showFilterOptions" tabindex="0" aria-describedby="showArrow" class="link">
              SHOW MORE SEARCH OPTIONS <span class="material-symbols-outlined">keyboard_arrow_down</span>
              <span id="showArrow" style="display: none">User can expand for advance search</span>
            </a>
          </div>
        }
        @if (showFilterOptions) {
          <div>
            <a (click)="showFilterOptions = !showFilterOptions" tabindex="0" aria-describedby="hideArrow" class="link">
              HIDE MORE SEARCH OPTIONS <span class="material-symbols-outlined">keyboard_arrow_up</span>
              <span id="hideArrow" style="display: none">User can collapse for advance search</span>
            </a>
          </div>
        }
      </div>
      @if (showFilterOptions) {
        <div class="space-me">
          <form [formGroup]="searchForm" (submit)="search(true)">
            <div class='filter-content'>
              <div class="grid-item">
                <mat-form-field appearance="outline" class="search">
                  <mat-label>Enter First Name</mat-label>
                  <input matInput type="textbox" formControlName="firstName">
                </mat-form-field>
              </div>
              <div class="grid-item">(OR)</div>
              <div class="grid-item">
                <mat-form-field appearance="outline"  class="search">
                  <mat-label>Enter Last Name</mat-label>
                  <input matInput type="textbox" formControlName="lastName">
                </mat-form-field>
              </div>
              <div class="grid-item">(OR)</div>
              <div class="grid-item">
                <mat-form-field appearance="outline" class="search">
                  <mat-label>Enter Plan Name</mat-label>
                  <input matInput type="textbox" formControlName="planName">
                </mat-form-field>
              </div>
              <div class="grid-item">(OR)</div>
              <div class="grid-row-wrapper">
                <div class="grid-item">
                  <mat-form-field appearance="outline" class="search">
                    <mat-label>Status</mat-label>
                    <mat-select aria-label="Status" formControlName="status">
                      @for (status of statuses; track status) {
                        <mat-option [value]="status">
                          {{status}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="grid-item">(OR)</div>
                <div class='grid-item'>
                  <div class="date">
                    <mat-form-field appearance="outline" class="search">
                      <mat-hint align="start">MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                      <mat-label>Creation Date Range</mat-label>
                      <mat-date-range-input
                        [formGroup]="searchForm"
                        [rangePicker]="campaignOnePicker"
                        [max] = "maxDate">
                        <input matStartDate matInput placeholder="From date" formControlName="fromDate">
                        <input matEndDate matInput placeholder="To date" formControlName="toDate">
                      </mat-date-range-input>
                      <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                      <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
                    </mat-form-field>
                    <div class="errorMsg">
                      @if (searchForm.get('fromDate').errors?.matStartDateInvalid) {
                        <mat-error> To date should be greater</mat-error>
                      }
                      @if (searchForm.get('toDate').errors?.matEndDateInvalid) {
                        <mat-error> From date should be lesser</mat-error>
                      }
                      @if (searchForm.get('fromDate').errors?.matDatepickerMax) {
                        <mat-error>From date should be less than or equal To date</mat-error>
                      }
                      @if (searchForm.get('toDate').errors?.matDatepickerMax) {
                        <mat-error>To date should be less than or equal current date</mat-error>
                      }
                      @if (searchForm.get('fromDate').errors?.matDatepickerMin) {
                        <mat-error>From date should be less than To date</mat-error>
                      }
                      @if (searchForm.get('fromDate').errors?.matDatepickerParse ||
                        searchForm.get('toDate').errors?.matDatepickerParse) {
                        <mat-error>
                        Enter valid date</mat-error>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      }
    </div>
    <br/>
    @if (plans.length === 0) {
      <p class='loading-container'>
        {{ planSearchMessage}}
      </p>
    }

    @if (plans.length > 0) {
      <div class='application-list'>
        @for (plan of plans; track plan) {
          <app-application-card [plan]=plan [retrieveUrl]="retrieveUrl" [viewUrl]="viewUrl"></app-application-card>
        }
      </div>
    }

  </div>
  <div class='footer'>
    <form [formGroup] = "plansPerPageForm">
      <mat-form-field appearance="outline" class='plans-per-page'>
        <mat-label>ITEMS PER PAGE:</mat-label>
        <mat-select aria-label="Items Per Page" (selectionChange)="refreshPlansPerPage($event)" [(value)]="plansPerPage" formControlName="plansPerPageFormControl">
          @for (number of noOfPlans; track number) {
            <mat-option [value]="number">
              {{number}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    <label>{{firstAppNo}}-{{lastAppNo}} OF {{totalApplications}}</label>
    <div class="navigational-controls">
      <div class="nav-link">
        <a id="previous" (click)="prev()" tabindex="0" [class]="{'disabled' : currentPage === 1}" class="material-symbols-outlined" aria-label="Previous">arrow_back_ios</a>
      </div>

      <div class="nav-link">
        <a id="next" (click)="next()" tabindex="0" [class]="{'disabled' : this.currentPage === this.totalPages || totalApplications === 0}" class="material-symbols-outlined" aria-label="Next">arrow_forward_ios</a>
      </div>

    </div>
  </div>
</div>
